/* <smooth-details>: wraps a <details> so it opens and closes with a height animation.
   Without this file the <details> still works natively (just without the animation). */
if (!customElements.get('smooth-details')) {
  customElements.define('smooth-details', class SmoothDetails extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.details && this.details.querySelector('summary');
      this.panel = this.details && this.details.querySelector('[data-accordion-panel]');
      if (!this.summary || !this.panel) return;
      this.summary.addEventListener('click', (event) => this.toggle(event));

      // Images in the panel are lazy in the HTML, and a closed <details> never triggers lazy loading.
      // Fetch them once the page has loaded, so they are sized and ready when the panel opens.
      const loadImages = () => this.panel.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      if (document.readyState === 'complete') loadImages();
      else window.addEventListener('load', loadImages, { once: true });
    }

    toggle(event) {
      event.preventDefault();
      if (this.animation) return;
      const opening = !this.details.open;
      if (opening) this.details.open = true;
      const closed = { height: '0px', paddingBottom: '0px' };
      const open = { height: this.panel.offsetHeight + 'px', paddingBottom: getComputedStyle(this.panel).paddingBottom };
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.panel.style.overflow = 'hidden';
      this.animation = this.panel.animate(opening ? [closed, open] : [open, closed], {
        duration: reduce ? 0 : 300,
        easing: 'cubic-bezier(.4, 0, .2, 1)'
      });
      this.animation.onfinish = this.animation.oncancel = () => {
        if (!opening) this.details.open = false;
        this.panel.style.overflow = '';
        this.animation = null;
      };
    }
  });
}
